import RoundInspectionModule from '../../../components/common/RoundInspection/RoundInspectionModule';
import AdminRulesDashboard from "../../../components/common/RulesAndRegulations/Admin/AdminRulesDashboard";
import MyRulesDashboard from "../../../components/common/RulesAndRegulations/User/MyRulesDashboard";
import AmenitiesModule from '../../../components/common/AmenitiesModule/AmenitiesModule';
import RolePermissionsMobile from '../../../components/common/RoleManagement/RolePermissionsMobile';
import EmergencyTypeList from '../../../components/common/EmergencyServices/EmergencyTypeList';
import EmergencyTypeForm from '../../../components/common/EmergencyServices/EmergencyTypeForm';
import ActiveEmergencyList from '../../../components/common/EmergencyServices/ActiveEmergencyList';
import RaiseEmergency from '../../../components/common/EmergencyServices/RaiseEmergency';
import EmergencyReports from '../../../components/common/EmergencyServices/EmergencyReports';

export const commonRoutes = [
  {
    path: "admin/rules-regulations",
    element: <AdminRulesDashboard />,
  },
  {
    path: "my-rules",
    element: <MyRulesDashboard />,
  },
  {
    path: "round-inspection",
    element: <RoundInspectionModule />,
  },
  {
    path: "round-inspection/*",
    element: <RoundInspectionModule />,
  },
  {
    path: "amenities-management",
    element: <AmenitiesModule />,
  },
  {
    path: "mobile-permissions",
    element: <RolePermissionsMobile />,
  },
  {
    path: "emergency-services/types",
    element: <EmergencyTypeList />,
  },
  {
    path: "emergency-services/types/add",
    element: <EmergencyTypeForm />,
  },
  {
    path: "emergency-services/types/add/:id",
    element: <EmergencyTypeForm />,
  },
  {
    path: "emergency-services/active",
    element: <ActiveEmergencyList />,
  },
  {
    path: "emergency-services/raise",
    element: <RaiseEmergency />,
  },
  {
    path: "emergency-services/reports",
    element: <EmergencyReports />,
  },
];
